import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, ButtonToolbar, Col, Row } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import { removeItem } from '../../../../redux/actions/cartActions'
import { StartOrder, FinishOrder } from '../../../../queries/products'
import { RemoveProductFromCart } from '../../../../queries/cart'
import { Mutation } from 'react-apollo';
// import MaskedInput from 'react-text-mask';
import TrialAlert from '../../../alerts/components/BorderedAlertsWithIcons';
import '../../../../scss/component/payment-form.scss'
// import Tracker from '../../../../analytics/Tracker';
// const tracker = new Tracker();


// import CreditCardIcon from 'mdi-react/CreditCardIcon';
// import renderRadioButtonField from '../../../form/RadioButton';

// const MasterCard = process.env.PUBLIC_URL + '/img/for_store/cards/mc.svg';
// const VisaCard = process.env.PUBLIC_URL + '/img/for_store/cards/visa.svg';
// const PayPal = process.env.PUBLIC_URL + '/img/for_store/cards/paypal.svg';

// const renderField = ({ input, label, placeholder, type, meta: { touched, error }, mask }) => (
//   <MaskedInput {...input} placeholder={placeholder} type={type} mask={mask} />
// );

var cardBrandToPfClass = {
  'visa': 'pf-visa',
  'mastercard': 'pf-mastercard',
  'amex': 'pf-american-express',
  'discover': 'pf-discover',
  'diners': 'pf-diners',
  'jcb': 'pf-jcb',
  'unknown': 'pf-credit-card',
}

class PaymentForm extends PureComponent {

  state = {
    employeeCount: 10,
    totalCost: this.props.price,
    internalError: null,
    formError: null,
    showErrorAlert: false,
    cardName: '',
    successMsg: null,
    submitting: false
  }



  setBrandIcon (brand) {
    var brandIconElement = document.getElementById('brand-icon');
    var pfClass = 'pf-credit-card';
    if (brand in cardBrandToPfClass) {
      pfClass = cardBrandToPfClass[brand];
    }
    for (var i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add('pf');
    brandIconElement.classList.add(pfClass);
  }

  submit = async (startOrder, finishOrder, removeProductFromCart) => {

    if (!this.props.user) {
      this.props.history.push('/unauthorized');
    }

    this.setState({ submitting: true })
    try {

      //1. Creates a new, unique token to send to the stripe api
      let createToken = await this.props.stripe.createToken({
        name: this.state.cardName,
        currency: "usd",
        type: 'card'
      });

      if (createToken.token && createToken.token.id) {
        //2. Create order with array of items: {quantity, productID, etc.}
        const startOrderResponse = await startOrder({
          variables: {
            order: {
              items: this.props.cartItems.map(cartItem => {
                return {
                  quantity: cartItem.quantity,
                  productID: cartItem.productID,
                  productName: cartItem.productName,
                  productShortDescription: cartItem.productShortDescription,
                  price: Number(cartItem.price).toFixed(2) / 100,
                  images: cartItem.images,
                  companyEmail: cartItem.companyEmail,
                  vendorName: cartItem.companyName || cartItem.vendorName
                }
              })

            }
          }
        })

        if (startOrderResponse.data &&
          startOrderResponse.data.createOrder) {
          //3. Use orderID and token to call finishOrder
          const finishOrderResponse = await finishOrder({
            variables: {
              completeOrder: {
                orderID: startOrderResponse.data.createOrder.orderID,
                token: createToken.token.id,
                givenName: this.props.user.given_name
              }
            }
          })

          if (finishOrderResponse.data &&
            finishOrderResponse.data.completeOrder) {
            this.setState({
              successMsg: `Order complete. Order Number: ${finishOrderResponse.data.completeOrder.orderID}`
            })

            //4. Remove items from cart
            this.props.cartItems.forEach(item => {
              removeProductFromCart({
                variables: {
                  productId: item.productID
                }
              })
              this.props.removeItem(item.productID);
            })
            this.setState({ totalCost: 0 })

          } else {
            this.setState({
              formError: 'Order could not be completed. Try again later'
            })
          }
        } else {
          this.setState({
            formError: 'Order could not be created. Try again later'
          })
        }
      } else {
        //there was some error creating the token, maybe the form is invalid
        this.setState({
          internalError: createToken.error.message,
          formError: 'Order could not be initiated. Try again later'
        })
      }
    } catch (err) {
      this.setState({
        formError: 'Order could not be completed. Try again later',
        internalError: err.message
      })
    } finally {
      this.setState({ submitting: false })
    }
  }

  render () {
    return (
      <div className="checkout">
        {this.state.formError ?
          <div>
            <TrialAlert
              level='danger' alertTag={'Error'} msg={`${this.state.formError}`} alertButton={false} />
          </div>
          : <div></div>
        }

        {this.state.successMsg ?
          <div>
            <TrialAlert level='success' alertTag={'Success'} msg={`${this.state.successMsg}`} alertButton={false} />
          </div>
          : <div></div>
        }

        <form className='form payment__credit-cards' onSubmit={this.submit}>
          <div className='form__form-group'>
            <Row>
              <Col md={12}>
                <span>Name on Card</span>
                <div style={{ display: "flex" }}>
                  <div id="cardName" className="StripeElement">
                    <input type="text" name="name" placeholder="Enter Name" onChange={(e) => {
                      this.setState({
                        cardName: e.target.value
                      })
                    }} value={this.state.cardName} required style={{ fontSize: "1em" }} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <span>Card Number</span>
                <div style={{ display: "flex" }}>
                  <div id="cardNum" className="StripeElement">
                    {/*} <CardElement />*/}
                    <CardNumberElement
                      onChange={(event) => {
                        return (event.brand) ? this.setBrandIcon(event.brand) : null
                      }} />
                  </div>
                  <span className="brand" style={{ paddingTop: "2.4em", width: 30, position: "absolute", left: '85%' }}>
                    <i className="pf pf-credit-card" id="brand-icon" style={{ color: "#8898AA" }}></i></span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label>Expiration Date</label>
                <div className="StripeElement">
                  <CardExpiryElement />
                </div>
              </Col>
              <Col md={6}>
                <label>CVC</label>
                <div className="StripeElement">
                  <CardCVCElement />
                </div>
              </Col>
            </Row>
            <h4 className='payment__total'>
              Total Price: ${this.state.totalCost}
            </h4>
            <hr />
          </div>
          <ButtonToolbar className='form__button-toolbar modal__footer'>
            <Mutation mutation={StartOrder()}>
              {(startOrder) => (
                <Mutation mutation={FinishOrder()}>
                  {(finishOrder) => (
                    <Mutation mutation={RemoveProductFromCart}>
                      {(removeProductFromCart) => (
                        this.state.submitting ?
                          <Button
                            color='primary'
                            style={{ cursor: 'progress', opacity: '0.65' }}
                            onClick={(e) => {
                              e.preventDefault()
                            }}
                          >Make Payment</Button> :
                          this.state.totalCost === 0 ?
                            <Button
                              color='primary'
                              style={{ cursor: 'not-allowed', opacity: '0.65' }}
                              onClick={(e) => {
                                e.preventDefault()
                              }}
                            >Make Payment</Button> :
                            <Button
                              color='primary'
                              onClick={(e) => {
                                e.preventDefault()
                                this.submit(startOrder, finishOrder, removeProductFromCart)
                              }}>Make Payment</Button>
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </Mutation>
          </ButtonToolbar>
        </form>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user,
    subscribeResponse: state.stripeData.subscribeResponse,
    cartItems: state.cartData.items,
  }
}

export default connect(mapStateToProps, { removeItem })(withRouter(injectStripe(PaymentForm)));



// WEBPACK FOOTER //
// ./src/components/e-commerce/payment/components/PaymentForm.js